module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie NotificationBar is a notification box useful for displaying important messages to the user.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;NotificationBar&gt;Your message goes here&lt;/NotificationBar&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/NotificationBar/README.md
// module id = 369
// module chunks = 0